import axios from "../../lib/axiosInstance";

export function fetchLocations() {
  return axios.get("locations").then((res) => res.data);
}
export function deleteLocation(id) {
  return axios.delete(`locations/${id}`).then((res) => res.data);
}
